// extracted by mini-css-extract-plugin
export var arrow = "index-module--arrow--gGMGI";
export var background = "index-module--background--06vFc";
export var details = "index-module--details--fRzva";
export var duration = "index-module--duration--A+q3G";
export var fullWidthVideoCalloutWrapper = "index-module--fullWidthVideoCalloutWrapper--gn54o";
export var playButton = "index-module--playButton--d0cxv";
export var subtitle = "index-module--subtitle--rzp5o";
export var title = "index-module--title--CJWoU";
export var videoPreview = "index-module--videoPreview--p7jk3";
export var videoWrapper = "index-module--videoWrapper--qM++b";
export var videoWrapperOverlay = "index-module--videoWrapperOverlay--+Y7Q9";